import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class PressRoomNews extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get slug() {
    return get(this, '_slug.value', '');
  }

  get title() {
    return get(this, '_tytul.value', '');
  }

  get publicationDate() {
    return get(this, '_data_publikacji.value', '');
  }

  get photo() {
    return get(this, '_zdjecie.value[0]', {});
  }

  get photoMiniature() {
    return get(this, '_zdjecie_miniaturka.value[0].url', '');
  }

  get pressRoomCategory() {
    return get(this, '_kategoria_press_room', []);
  }

  get text() {
    return get(this, '_tresc.value', '');
  }

  get comments() {
    return get(this, '_komentarz', []);
  }

  get filesName() {
    return get(this, '_pozostale_zalaczniki.value[0].name', '');
  }

  get filesSize() {
    return get(this, '_pozostale_zalaczniki.value[0].size', '');
  }

  get filesUrl() {
    return get(this, '_pozostale_zalaczniki.value[0].url', '');
  }

  get txt() {
    return get(this, '_artykul_w__txt.value', []);
  }

  get pdf() {
    return get(this, '_artykul_w__pdf.value', []);
  }

  get doc() {
    return get(this, '_artykul_w__doc.value', []);
  }

  get img() {
    return get(this, '_pozostale_zalaczniki', []);
  }

  get seo() {
    const seoModel = get(this, '_seo.value[0].model', {});

    if (!seoModel.title) {
      seoModel.title = this.title;
    }

    return seoModel;
  }

  get type() {
    return get(this, 'system.type', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/ArticleNews.js